module.exports = __webpack_public_path__ + "img/A1-4-plan.63a9f58f.png";